export enum InputStyles {
  FILLED = 'filled',
  OUTLINED = 'outlined',
}
